import AXIOS from "axios";
import URL from "./url";
import VUE from "../main";
import { Store } from "../store";
const API = {
  consumoSinEncaje(interes, capital, plazo) {
    let consumoSinEncaje = AXIOS.get(URL.consumoSinEncaje, {
      params: { interes: interes, capital: capital, plazo: plazo },
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => console.log(err));
    return consumoSinEncaje;
  },
  dummyResponse(interes, capital, plazo, tipoCredito, tipoCuota) {
    Store.dispatch("setIsLoading", true);
    let consumoSinEncaje = AXIOS.get(URL.dummyResponse, {
      params: {
        interes: interes,
        capital: capital,
        plazo: plazo,
        tipoCredito: tipoCredito,
        tipoCuota: tipoCuota,
      },
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        VUE.$notify({
          title: "LO SENTIMOS :(",
          text: "!Al parecer tuvimos un problema¡",
          type: "error",
        });
        console.log(err);
      })
      .finally(() => {
        Store.dispatch("setIsLoading", false);
      });
    return consumoSinEncaje;
  },
  parametrosCoac(coacId) {
    Store.dispatch("setIsLoading", true);
    let parametrosCoac = AXIOS.get(URL.parametrosCoac + coacId)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        VUE.$notify({
          title: "LO SENTIMOS :(",
          text: "!Al parecer tuvimos un problema¡",
          type: "error",
        });
        console.log(err);
      })
      .finally(() => {
        Store.dispatch("setIsLoading", false);
      });
    return parametrosCoac;
  },
  parametrosCoacAhorros(coacId) {
    Store.dispatch("setIsLoading", true);
    let parametrosCoacAhorros = AXIOS.get(URL.parametrosCoacAhorros + coacId)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        VUE.$notify({
          title: "LO SENTIMOS :(",
          text: "!Al parecer tuvimos un problema¡",
          type: "error",
        });
        console.log(err);
      })
      .finally(() => {
        Store.dispatch("setIsLoading", false);
      });
    return parametrosCoacAhorros;
  },
  async calculoPrestamo(capital, plazo, tipoCredito, tipoCuota) {
    let parametrosCoac = Store.getters.getParametrosCoac;
    let index = parametrosCoac.creditos.findIndex(
      (cc) => cc.idCredito === tipoCredito
    );
    console.log("calculoPrestamo", index);
    let tipoCreditoSeleccionado = parametrosCoac.creditos[index];
    Store.dispatch("setIsLoading", true);
    let calculoPrestamo = await AXIOS.post(URL.calculoPrestamo, {
      capital: parseInt(capital),
      interes: parseFloat(tipoCreditoSeleccionado.tasaNominal),
      plazo: parseInt(plazo),
      seguro: parseFloat(tipoCreditoSeleccionado.tasaSeguro),
      encaje: parseFloat(tipoCreditoSeleccionado.porcentajeEncaje),
      tasaPasiva: parseFloat(tipoCreditoSeleccionado.porcentajeTasaPasiva),
      idCuota: tipoCuota,
      tasaEfectivaAnual: parseFloat(tipoCreditoSeleccionado.tasaEfectivaAnual),
    })
      .then((res) => {
        return res.data.pop();
      })
      .catch((err) => {
        VUE.$notify({
          title: "LO SENTIMOS :(",
          text: "!Al parecer tuvimos un problema¡",
          type: "error",
        });
        console.log(err);
      })
      .finally(() => {
        Store.dispatch("setIsLoading", false);
      });
    console.log(calculoPrestamo);
    return calculoPrestamo;
  },
  async calculoAhorros(interes, plazo, cuotaAhorro, monto, tipoAhorro) {
    console.log(interes, plazo, cuotaAhorro, monto, tipoAhorro.id);
    Store.dispatch("setIsLoading", true);

    let cuotaAhorroLocal = "";
    if (cuotaAhorro) cuotaAhorroLocal = parseFloat(cuotaAhorro);
    let calculoAhorro = await AXIOS.post(URL.calculoAhorros, {
      interes: interes,
      plazo: parseInt(plazo),
      cuotaAhorro: cuotaAhorroLocal,
      monto: parseFloat(monto),
      tipoAhorro: tipoAhorro.descripcion,
    })
      .then((res) => {
        return res.data.pop();
      })
      .catch((err) => {
        VUE.$notify({
          title: "LO SENTIMOS :(",
          text: "!Al parecer tuvimos un problema¡",
          type: "error",
        });
        console.log(err);
      })
      .finally(() => {
        Store.dispatch("setIsLoading", false);
      });

    return calculoAhorro;
  },
};

export default API;
